import { twMerge } from 'tailwind-merge';
import { PropsWithChildren } from 'react';

import { Nullable } from 'types';
import { TopNavigation } from 'components';

import { Background } from '../background';

interface PrivateLayoutProps extends PropsWithChildren {
  logoUrl?: Nullable<string>;
}

export const PrivateLayout = ({ logoUrl, children }: PrivateLayoutProps) => (
  <div className="flex min-h-screen w-screen">
    <Background className="fixed top-0 bottom-0 left-0 z-[1] w-screen" />
    <div className="relative z-10 flex w-full flex-col">
      <div className="bg-accent-primary sticky top-0 right-0 left-0 z-20">
        <Wrapper>
          <TopNavigation logoUrl={logoUrl} />
        </Wrapper>
      </div>
      <Wrapper className="flex min-h-0 flex-1 flex-col py-4 md:py-8">
        {children}
      </Wrapper>
    </div>
  </div>
);

const Wrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={twMerge(
      'w-full px-4 md:px-6 lg:mx-auto lg:max-w-[calc(1280px+(--spacing(12)))]',
      className
    )}
  >
    {children}
  </div>
);
